// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleLockup_root__3J5Am"};